export const userInfo = {

    //Basic info
    basicHead: 'Pro Info ',
    logo: 'Logo',
    company: 'Company Name',
    name: 'Name',
    address: 'Address',
    email: 'Primary Email',
    phone: 'Cell Phone Number',
    profile: 'Profile',

    //References

    qualityRef: 'Quality of Work References',
    qualityColumn: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email'
    },
    personRef: 'Personality References',
    personColumn: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email'
    },
    noStory: 'No Story Added',
    noRef: ' No references added',

    // Skills
    skillHead: 'Skills',
    skill: 'The Skills',
    proficiency: 'Proficiency',
    license: 'Licensed for this?'
}

export const skills = [
    {
        key: 'roughCarpentry', //For dropdown refernce in db
        keyRadio: 'roughRadio', //For radio refernce in db
        temp: 'Rough Carpentry',
        label: 'Rough Carpentry',
    },
    {
        key: 'finishCarpentry',
        keyRadio: 'finishRadio',
        label: 'Finish Carpentry',
    },
    {
        key: 'plumbing',
        keyRadio: 'plumbingRadio',
        label: 'Plumbing',
    },
    {
        key: 'electrical',
        keyRadio: 'electricalRadio',
        label: 'Electrical',
    },
    {
        key: 'hvac',
        keyRadio: 'hvacRadio',
        label: 'HVAC',
    },
    {
        key: 'exteriorRoofingSidingGutters',
        keyRadio: 'exteriorRadio',
        label: 'Exterior (roofing/siding/gutters)',
    },
    {
        key: 'sheetrockInstall',
        keyRadio: 'sheetrockInstallRadio',
        label: 'Sheetrock Install',
    },
    {
        key: 'sheetrockFinish',
        keyRadio: 'sheetrockFinishRadio',
        label: 'Sheetrock install & finish',
    },
    {
        key: 'paint',
        keyRadio: 'paintRadio',
        label: 'Paint',
    },
    {
        key: 'appliances',
        keyRadio: 'appliancesRadio',
        label: 'Appliances',
    },
    {
        key: 'windowDoors',
        keyRadio: 'windowDoorsRadio',
        label: 'Window & Doors',
    },
    {
        key: 'handymanWork',
        keyRadio: 'handymanWorkRadio',
        label: 'Handyman work',
    },
    {
        key: 'generalRemodel',
        keyRadio: 'generalRemodelRadio',
        label: 'General Remodel',
    },
    {
        key: 'bathroomRemodeling',
        keyRadio: 'bathroomRemodelingRadio',
        label: 'Bath / Kit Remodel',
    }
];
export const skillDropdown = [
    {
        key: 'Heard of It',
        label: 'Heard of It',
    },
    {
        key: 'I know how',
        label: 'I know how',
    },
    {
        key: 'I am a skilled',
        label: "I'm a skilled",
    },
    {
        key: 'I am a Pro',
        label: "I'm a Pro",
    },
    {
        key: 'I am the best!',
        label: 'I am the best!',
    }
];
export const skillRadio = [
    {
        key: 'Yes',
        label: 'Yes',
    },
    {
        key: 'No',
        label: 'No',
    },
    {
        key: 'N/A',
        label: 'N/A',
    }
]


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/e-commerce/userInfo.ts